import EligibilityCheckForm from "@/components/EligibilityCheckForm";

/**
 * Inline SAINT eligibility form block — embeds the actual EligibilityCheckForm
 * (the same 7-field form used on /saint with the same tracking) directly on
 * the page rather than linking out. Rendered as a bare block (no outer
 * <section>) so it nests cleanly inside a section container.
 *
 * Used below the intro and again at the end of
 * /understanding-your-phq-9-and-gad-7-scores and
 * /learn/why-still-depressed-while-taking-medication.
 */
export const InlineEligibilityForm = ({
  source = "inline-eligibility",
  heading = "See if SAINT® is right for you",
  subheading = "Five questions. No obligation. A real answer from our clinical team.",
}: {
  source?: string;
  heading?: string;
  subheading?: string;
}) => {
  return (
    <div className="not-prose my-6">
      <div className="mb-6 text-center">
        <h2 className="font-headings text-2xl font-bold text-primary sm:text-3xl">
          {heading}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">{subheading}</p>
      </div>
      <EligibilityCheckForm
        source={source}
        variant="card"
        redirectTo="/thank-you-eligibility"
      />
    </div>
  );
};

export default InlineEligibilityForm;
